var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTwitter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "twitter@2x")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.0\\u6539\\u7248",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pool_\\u79FB\\u9664\\u6D41\\u52A8\\u6027_\\u9AD8\\u7EA7\\u6A21\\u5F0F",
    transform: "translate(-580.000000, -1202.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14",
    transform: "translate(580.000000, 1171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    transform: "translate(0.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.372583,0 0,5.372583 0,12 C0,18.627417 5.372583,24 12,24 C18.627417,24 24,18.627417 24,12 C24,8.81740212 22.7357179,5.76515517 20.4852814,3.51471863 C18.2348448,1.26428208 15.1825979,0 12,0 Z",
    id: "\\u5F62\\u72B6",
    fill: "#7569E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7925,10.1325 C16.7925,10.2375 16.7925,10.3425 16.7925,10.455 C16.7910385,13.0169369 15.3925785,15.3741748 13.1448395,16.6034803 C10.8971004,17.8327858 8.15787291,17.7384805 6,16.3575 C7.30431039,16.511681 8.616793,16.1451561 9.6525,15.3375 C8.59852414,15.3178528 7.67343409,14.6308153 7.35,13.6275 C7.50320837,13.6573077 7.65891897,13.6723764 7.815,13.6725 C8.03560917,13.6727266 8.25518961,13.6424396 8.4675,13.5825 C7.3172425,13.3506775 6.48933746,12.3408843 6.4875,11.1675 L6.4875,11.1675 C6.83030192,11.3572725 7.21336884,11.4626801 7.605,11.475 C6.52557678,10.7471992 6.19728628,9.30600394 6.855,8.1825 C8.10745417,9.7246676 9.95583268,10.662488 11.94,10.7625 C11.6875362,9.67617077 12.195145,8.55554383 13.1782419,8.0288848 C14.1613387,7.50222576 15.3754913,7.70048052 16.14,8.5125 C16.6929679,8.40361369 17.2231575,8.20067029 17.7075,7.9125 C17.5233854,8.48478514 17.1366782,8.97016934 16.62,9.2775 C17.0981365,9.20606043 17.5631331,9.06453973 18,8.8575 C17.6759508,9.35047186 17.2671345,9.78214125 16.7925,10.1325 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF"
  })))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwitter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/twitter.a3d04e9f.svg";
export { ForwardRef as ReactComponent };